import React from 'react';
import LotteryHead from './lotteryHead';
import LotteryParticipate from './lotteryParticipate';
import LotteryMystery from './lotteryMystery';
import LotteryRules from './lotteryRules';
import LotteryLower from './lotteryLower';

export default function Lottery() {
  return (
    <>
      <LotteryHead />
      <LotteryParticipate />
      <LotteryMystery />
      <LotteryRules />
      <LotteryLower />
    </>
  )
}
